import React from "react";
import GiftCardMenuDymanic from "app/modules/info/GiftCardMenuDymanic/GiftCardMenuDymanic.component";
import { SectionTopNext, DivSet4 } from "./styles";

const GiftCardMenu = ({ locations }) => {
    return (
        <>
            <SectionTopNext>
                {locations.length > 0 &&
                    locations.map((item, key) => (
                        <DivSet4 key={key}>
                            <GiftCardMenuDymanic item={item} keyData={key} />
                        </DivSet4>
                    ))
                }
            </SectionTopNext>
        </>
    )
}

export default GiftCardMenu;